import React from 'react';
import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-marriage-status-title']),
    livedContinuouslyWithVeteran: yesNoUI({
      title: content['household-marriage-status-lived-continuously'],
    }),
    'view:livingContinuouslyInfo': {
      'ui:description': () => (
        <va-additional-info
          trigger={content['household-marriage-status-lived-info-trigger']}
        >
          <p>{content['household-marriage-status-lived-continuously-info']}</p>
        </va-additional-info>
      ),
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['livedContinuouslyWithVeteran'],
    properties: {
      livedContinuouslyWithVeteran: yesNoSchema,
      'view:livingContinuouslyInfo': {
        type: 'object',
        properties: {},
      },
    },
  },
};
